import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './custom-ie11-polyfill';
import './Shared/eventHandling';
import { AppProvider } from '@abbott-components/core';
import { render } from 'react-dom';
import { SnackbarProvider } from 'notistack';
import App from './App/App';
import React from 'react';
import reportWebVitals from './reportWebVitals';
import './index.css';
import WorkflowEngine from './WorkflowEngine/WorkflowEngine';
import { WorkflowEngineMode } from './WorkflowEngine/workflowEngineReducer';
import config from './Shared/config';

const { rootEl, role, entryExternalId } = config;

render(
  <React.StrictMode>
    <AppProvider>
      <SnackbarProvider
        maxSnack={1}
        autoHideDuration={5000}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'top'
        }}
      >
        {entryExternalId ? (
          <WorkflowEngine
            role={role}
            externalId={entryExternalId}
            mode={WorkflowEngineMode.ENTRY}
          />
        ) : (
          <App role={role} />
        )}
      </SnackbarProvider>
    </AppProvider>
  </React.StrictMode>,
  rootEl
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
